import { ProjectParameter } from '@deltek/specification-client/core/Models/projectParameter'

export const availableProjectParamters = [
    { name: 'Building Type', label: 'Building Type', multiple: false },
    { name: 'Contract Type', label: 'Contract Type', multiple: true },
    { name: 'Construction Type', label: 'Construction Type', multiple: false },
    { name: 'Sustainability Type', label: 'Sustainability', multiple: false },
    { name: 'Owner Type', label: 'Owner', multiple: false },
    { name: 'Geographic Region', label: 'Geographic Region', multiple: false },
    { name: 'Seismic Zone', label: 'Seismic Zone', multiple: false },
    { name: 'Wind Zone', label: 'Wind Zone', multiple: false },
]

export const getSelectedProjectParameterValue = (
    parametersList: Partial<ProjectParameter>[],
    currentModifier: string
) => {
    let selectedModifierValues: string = ''
    if (parametersList?.length) {
        const selectedModifierData = parametersList
            .filter((param: Partial<ProjectParameter>) => {
                return param.modifierList?.name === currentModifier
            })[0]
            ?.selectedModifiers?.map(
                (selectedModifierItem) => selectedModifierItem.name
            )
        if (selectedModifierData?.length) {
            selectedModifierValues = selectedModifierData.join(', ')
        }
    }

    return selectedModifierValues
}
